import { TXTextTemplate } from "../../../types/common/templates.types";

export const X_TEXT_TEMPLATES: TXTextTemplate = {
  "Paragraphe 1": {
    template: [
      {
        name: "XText",
        props: { all: { tag: "body1", text: "Paragraphe 1" } },
      },
    ],
  },
  "Paragraphe 2": {
    template: [
      {
        name: "XText",
        props: { all: { tag: "body2", text: "Paragraphe 1" } },
      },
    ],
  },
  H1: {
    template: [
      {
        name: "XText",
        props: { all: { tag: "h1", text: "Heading 1" } },
      },
    ],
  },
  H2: {
    template: [
      {
        name: "XText",
        props: { all: { tag: "h2", text: "Heading 2" } },
      },
    ],
  },
  H3: {
    template: [
      {
        name: "XText",
        props: { all: { tag: "h3", text: "Heading 3" } },
      },
    ],
  },
  H4: {
    template: [
      {
        name: "XText",
        props: { all: { tag: "h4", text: "Heading 4" } },
      },
    ],
  },
  H5: {
    template: [
      {
        name: "XText",
        props: { all: { tag: "h5", text: "Heading 5" } },
      },
    ],
  },
  H6: {
    template: [
      {
        name: "XText",
        props: { all: { tag: "h6", text: "Heading 6" } },
      },
    ],
  },
  "Sous-Titre 1": {
    template: [
      {
        name: "XText",
        props: { all: { tag: "subtitle1", text: "Sous-Titre 1" } },
      },
    ],
  },
  "Sous-Titre 2": {
    template: [
      {
        name: "XText",
        props: { all: { tag: "subtitle2", text: "Sous-Titre 2" } },
      },
    ],
  },
  Caption: {
    template: [
      {
        name: "XText",
        props: {
          all: {
            tag: "caption",
            text: "Caption",
          },
        },
      },
    ],
  },
  OverLine: {
    template: [
      {
        name: "XText",
        props: {
          all: {
            tag: "overline",
            text: "OVERLINE",
          },
        },
      },
    ],
  },
};
